export default __webpack_public_path__ + "static/media/Izidor Emmanuel.6f515d67.jpg";